import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { Card, CardContent, CardMedia, CardActions, Chip } from "@mui/material";

const ServerShop = ({
    items,
    categories,
    selectedCategory,
    onCategoryChange,
    usersInfo,
    isAuth,
    isPurchasing,
    onNeedAuth,
    onBuy,
    onNeedTopUp,
}) => (
    <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>
            Магазин сервера
        </Typography>
        <Box sx={{ mb: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
            <Chip
                label="Все"
                clickable
                color={selectedCategory === "all" ? "primary" : "default"}
                variant={selectedCategory === "all" ? "filled" : "outlined"}
                onClick={() => onCategoryChange("all")}
            />
            {categories.map((category) => (
                <Chip
                    key={category}
                    label={category}
                    clickable
                    color={selectedCategory === category ? "primary" : "default"}
                    variant={selectedCategory === category ? "filled" : "outlined"}
                    onClick={() => onCategoryChange(category)}
                />
            ))}
        </Box>

        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
            {items.map((item) => {
                const hasSufficientFunds =
                    usersInfo?.balance !== undefined &&
                    parseFloat(usersInfo.balance ?? 0) + parseFloat(usersInfo.bonuses ?? 0) >= parseFloat(item.price);

                return (
                    <Card
                        key={item.id}
                        sx={{
                            width: { xs: "100%", sm: "calc(50% - 8px)", md: "calc(33.333% - 12px)" },
                            display: "flex",
                            flexDirection: "column",
                        }}
                        variant="outlined"
                        elevation={2}
                    >
                        <CardMedia
                            component="img"
                            height="140"
                            image={item.custom_image_url || item.image_url || "/storage/images/items/no_image.png"}
                            alt={item.custom_name || item.name || "Предмет"}
                            sx={{ objectFit: "contain", pt: 2 }}
                            onError={(event) => {
                                event.target.src = "/storage/images/items/no_image.png";
                            }}
                        />
                        <CardContent sx={{ flexGrow: 1 }}>
                            <Typography gutterBottom variant="h6" component="div">
                                {item.custom_name || item.name || `Предмет #${item.id}`}
                            </Typography>
                            {item.custom_description && (
                                <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: "pre-line" }}>
                                    {item.custom_description}
                                </Typography>
                            )}
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                                <Typography variant="h6" color="primary">
                                    {item.price} ₽
                                </Typography>
                                <Chip label={`x${item.stock}`} size="small" color={item.stock > 0 ? "success" : "error"} />
                            </Box>
                        </CardContent>
                        <CardActions>
                            <Button
                                size="small"
                                variant="contained"
                                fullWidth
                                disabled={item.stock <= 0 || !isAuth || isPurchasing}
                                color={!hasSufficientFunds && isAuth ? "inherit" : "primary"}
                                onClick={() => {
                                    if (!isAuth) {
                                        onNeedAuth();
                                        return;
                                    }

                                    if (hasSufficientFunds) {
                                        onBuy(item);
                                    } else {
                                        onNeedTopUp(item);
                                    }
                                }}
                            >
                                {isPurchasing ? (
                                    <CircularProgress size={20} color="inherit" />
                                ) : item.stock <= 0 ? (
                                    "Нет в наличии"
                                ) : !isAuth ? (
                                    "Войдите для покупки"
                                ) : hasSufficientFunds ? (
                                    "Купить"
                                ) : (
                                    "Пополнить баланс"
                                )}
                            </Button>
                        </CardActions>
                    </Card>
                );
            })}
        </Box>
    </Box>
);

export default ServerShop;
